export default __webpack_public_path__ + "static/media/dog_v1.e53bc1a1.png";